export const TABLE_TITLE = 'Measurements for';
export const IO_OPTIONS = { rootMargin: '0px 0px -200px 0px' };
export const ANIMATION_TIME = 350;
export const SVG_SIZE = 156;
export const PAGE_PADDING = 16;
export const SCROLL_BUFFER = 10;
